const brlCurrencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const brlMoneyInputFormatter = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function timeAgo(dateString: string): string {
  const now = Date.now();
  const then = new Date(dateString).getTime();
  const diffMs = now - then;
  const diffMin = Math.floor(diffMs / 60_000);

  if (diffMin < 1) return "agora";
  if (diffMin < 60) return `há ${diffMin} min`;

  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return diffHr === 1 ? "há 1 hora" : `há ${diffHr} horas`;

  const diffDays = Math.floor(diffHr / 24);
  return diffDays === 1 ? "há 1 dia" : `há ${diffDays} dias`;
}

export function formatDateBR(dateString: string): string {
  const d = new Date(dateString);
  const day = String(d.getUTCDate()).padStart(2, "0");
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const year = d.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

export function formatBRL(value: number): string {
  return brlCurrencyFormatter.format(value || 0);
}

export function formatMoneyInput(
  value: string | number | null | undefined,
): string {
  if (value == null) return "";

  const digits =
    typeof value === "number"
      ? String(Math.round(Math.abs(value) * 100))
      : value.replace(/\D/g, "");

  if (!digits) return "";

  return brlMoneyInputFormatter.format(Number.parseInt(digits, 10) / 100);
}

export function parseMoneyInput(value: string): number | null {
  const digits = value.replace(/\D/g, "");
  if (!digits) return null;
  return Number.parseInt(digits, 10) / 100;
}
